var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_27847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6965 10.1399C38.2469 8.46922 36.9296 7.15228 35.2592 6.7024C32.2073 5.86719 19.9996 5.86719 19.9996 5.86719C19.9996 5.86719 7.79224 5.86719 4.74032 6.67056C3.10203 7.12015 1.75266 8.46952 1.30307 10.1399C0.5 13.1916 0.5 19.5203 0.5 19.5203C0.5 19.5203 0.5 25.881 1.30307 28.9008C1.75296 30.5712 3.0699 31.8884 4.74061 32.3383C7.82437 33.1735 19.9999 33.1735 19.9999 33.1735C19.9999 33.1735 32.2073 33.1735 35.2592 32.3701C36.9299 31.9205 38.2469 30.6033 38.6968 28.9329C39.4998 25.881 39.4998 19.5525 39.4998 19.5525C39.4998 19.5525 39.532 13.1916 38.6965 10.1399Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1133 25.3654L26.2646 19.5186L16.1133 13.6719V25.3654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_27847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtPlay);
export default __webpack_public_path__ + "static/media/yt-play.da21427f3f223c4357dd2ef6ea20cf4c.svg";
export { ForwardRef as ReactComponent };